<div class="wrapper">
  <div class="parent">
    <div class="left raci-steps" *ngIf="activeTab == raciTabs.Overview">
      <div class="valuation-event-title">
        <h3>
          {{portfolio?.ProjectName?.toUpperCase()}}
          <span *ngIf="activePortfolio?.valuationPortfolioName">
            &nbsp; | &nbsp;{{activePortfolio?.valuationPortfolioName?.toUpperCase()}}
          </span>
        </h3>
        <br />
      </div>
      <raci-steps-pane *ngIf="activeTab == raciTabs.Overview"
                       [activeStep]="activeStep"
                       [activeTask]="activeTask"
                       [activePortfolio]="activePortfolio"
                       (onChangeActiveStep)="setActiveStep($event)"
                       (onChangeActiveTask)="setActiveTask($event)"
                       (onCompleteStep)="completeStep($event)"
                       (onCompleteFunctionTask)="completeFunctionTask($event)"
                       [steps]="steps"
                       [shouldShowConfirmDialog]="showConfirmDialog"></raci-steps-pane>
    </div>
    <div class="main raci-checklist" *ngIf="activeTab == raciTabs.Overview">
      <div *ngIf="activePortfolio?.oid && activeStep && !activeTask"
           class="main-pane-info">
        <h2>{{activeStep?.stepName?.toUpperCase()}}</h2>
        <p *ngIf="!activeStep?.isCompleted">{{'raci.host.completeStep' | translate }}</p>
        <div *ngIf="activeStep?.relatedSteps?.length > 0">
          <span>{{'raci.host.orderToCompleteStep' | translate }}</span>
          <span *ngFor="let step of activeStep?.relatedSteps; index as i;"> {{step.stepName}}<span *ngIf="i < activeStep?.relatedSteps.length - 1">, </span></span>
        </div>
        <p *ngIf="activeStep?.isCompleted">{{'raci.host.doneBy' | translate }} {{activeStep?.stepModifiedByUserName}} on {{activeStep?.stepDateModified | date: 'dd.MM.YYYY'}}</p>
      </div>
      <div class="main-pane-info" *ngIf="activeStep && activeTask">
        <h2>{{activeStep?.stepName?.toUpperCase()}}</h2>
        <h3 class="inline-elements">
          {{activeTask.taskName}}
          <span kendoTooltip>
            <svg-icon *ngIf="activeTask.taskTypeId == taskTypes.ArgusSyncFunction"
                      src='./assets/icons/information-circle-outline.svg'
                      title="  {{'raci.portfolioProperties.argusPushSubTitle' | translate}}"
                      class="menu-action-icon svg-icon-black p-5"
                      align='center'></svg-icon>
          </span>
          <span kendoTooltip *ngIf="activeTask.taskTypeId == taskTypes.ArgusFunction">
            <svg-icon src='./assets/icons/information-circle-outline.svg'
                      title="{{'raci.portfolioProperties.argusTooltip' | translate}}"
                      class="menu-action-icon svg-icon-black p-5"
                      align='center'></svg-icon>
          </span>
          <span kendoTooltip *ngIf="activeTask.taskTypeId == taskTypes.ValuationEventFunction">
            <svg-icon src='./assets/icons/information-circle-outline.svg'
                      title="{{'valEventSetupForm.pageDescription' | translate }} {{activePortfolio?.ValuationPortfolioName}}"
                      class="menu-action-icon svg-icon-black p-5"
                      align='center'></svg-icon>
          </span>
          <span kendoTooltip *ngIf="activeTask.taskTypeId == taskTypes.CloseValuationEvent">
            <svg-icon src='./assets/icons/information-circle-outline.svg'
                      title="{{'raci.closeValuationEvent.closeValuationEventDescription' | translate }}"
                      class="menu-action-icon svg-icon-black p-5"
                      align='center'></svg-icon>
          </span>
        </h3>
        <div *ngIf="activeStep?.relatedSteps?.length > 0">
          <span>{{'raci.host.orderToCompleteStep' | translate }}</span>
          <span *ngFor="let step of activeStep?.relatedSteps; index as i;"> {{step.stepName}}<span *ngIf="i < activeStep?.relatedSteps.length - 1">, </span></span>
        </div>

        <p *ngIf="activeTask?.approvalMatrix?.length > 0 && activeTask?.taskActionStage == actionStage.Undefined && (activeTask.taskTypeId == taskTypes.ArgusFunction || activeTask.taskTypeId == taskTypes.ArgusSyncFunction)">
          {{'raci.host.orderToSyncWithArgus' | translate }}
        </p>
        <p *ngIf="activeTask?.approvalMatrix?.length > 0 && activeTask?.taskActionStage == actionStage.Undefined && activeTask.taskTypeId == taskTypes.ValoremFunction ">
          {{'raci.host.orderToPublishToValorem' | translate }}
        </p>
        <p *ngIf="(!activeTask.taskTypeId || activeTask.taskTypeId == taskTypes.Approval) && activeTask.taskActionStage == actionStage.Undefined">
          {{'raci.host.orderToGiveApproval' | translate }}
        </p>
        <p *ngIf="activeTask?.taskActionStage == actionStage.Undefined && activeTask.taskTypeId == taskTypes.CloseValuationEvent">
          {{'raci.host.orderToCloseValuationEventProject' | translate }}
        </p>
        <p *ngIf="activeTask?.taskActionStage == actionStage.Undefined && activeTask.taskTypeId == taskTypes.ValuationEventFunction">
          {{'raci.host.orderToSetupValuationInformation' | translate }}
        </p>
        <p *ngIf="activeTask?.taskActionStage == actionStage.Undefined && activeTask.taskTypeId == taskTypes.ValuationEffectiveDatesSetup">
          {{'raci.host.orderToSetupEffectiveDates' | translate }}
        </p>
        <div *ngIf="activeTask?.relatedTasks?.length > 0">
          <span>{{'raci.host.orderToCompleteTasks' | translate }}</span>
          <span *ngFor="let task of activeTask?.relatedTasks; index as i;"> {{task.taskName}}<span *ngIf="i < activeTask?.relatedTasks.length - 1">, </span></span>
        </div>
      </div>
      <portfolio-properties *ngIf="activePortfolio?.oid && activeTask?.projectTaskId && activeTask?.approvalMatrix?.length > 0 && (activeTask.taskTypeId == taskTypes.Approval || activeTask.taskTypeId == taskTypes.Undefined)"
                            [data]="activeTask?.approvalMatrix"
                            [currentUser]="currentUser"
                            [activePortfolioId]="activePortfolio?.oid"
                            [activeProjectId]="projectId"
                            [activeStepId]="activeStep?.projectStepId"
                            [activeTaskId]="activeTask?.projectTaskId"
                            [disableApproval]="activeTask?.taskActionStage != actionStage.Waiting || activePortfolio.isFinalized"
                            [groupBy]="groupBy"
                            (onUpdateApprovalMatrix)="saveApprovalChanges($event)"
                            (shouldShowDialog)="setShouldShowConfirmDialog($event)"
                            (updateCompleteTaskStatus)="updateCompleteTaskStatus($event)"
                            (refreshUserTaskList)="refreshUserTasks()"></portfolio-properties>

      <argus-push-matrix *ngIf="activePortfolio?.oid && activeTask?.projectTaskId && activeTask?.approvalMatrix?.length > 0 && activeTask.taskTypeId == taskTypes.ArgusSyncFunction"
                         [data]="activeTask?.approvalMatrix"
                         [lastSyncInfo]="argusLastSyncInfo"
                         [numberOfSyncProp]="argusNumberOfSyncProp"
                         [currentUser]="currentUser"
                         [activePortfolioId]="activePortfolio?.oid"
                         [activeProjectId]="projectId"
                         [activeStepId]="activeStep?.projectStepId"
                         [activeTaskId]="activeTask?.projectTaskId"
                         [groupBy]="groupBy"
                         [currentTask]="activeTask"
                         (updateActiveTask)="updateActiveTask($event)"
                         (shouldShowDialog)="setShouldShowConfirmDialog($event)"
                         (updateCompleteTaskStatus)="updateCompleteTaskStatus($event)"
                         (refreshUserTaskList)="refreshUserTasks()"
                         [allowSync]="isApprovingAllowed()"></argus-push-matrix>
      <argus-approval-matrix *ngIf="activePortfolio?.oid && activeTask?.projectTaskId && activeTask?.approvalMatrix?.length > 0 && activeTask.taskTypeId == taskTypes.ArgusFunction"
                             [data]="activeTask?.approvalMatrix"
                             [currentUser]="currentUser"
                             [activePortfolioId]="activePortfolio?.oid"
                             [activeProjectId]="projectId"
                             [activeStepId]="activeStep?.projectStepId"
                             [activeTaskId]="activeTask?.projectTaskId"
                             [groupBy]="groupBy"
                             [currentTask]="activeTask"
                             (updateActiveTask)="updateActiveTask($event)"
                             (shouldShowDialog)="setShouldShowConfirmDialog($event)"
                             (updateCompleteTaskStatus)="updateCompleteTaskStatus($event)"
                             (refreshUserTaskList)="refreshUserTasks()"
                             (onSyncWithArgus)="syncWithArgus($event)"
                             [allowSync]="isApprovingAllowed()"></argus-approval-matrix>

      <valorem-approval-matrix *ngIf="activePortfolio?.oid && activeTask?.projectTaskId && activeTask?.approvalMatrix?.length > 0 && activeTask.taskTypeId == taskTypes.ValoremFunction"
                               [data]="activeTask?.approvalMatrix"
                               [activePortfolioId]="activePortfolio?.oid"
                               [activeProjectId]="projectId"
                               [groupBy]="groupBy"
                               [currentTask]="activeTask"
                               [allowApproving]="isApprovingAllowed()"
                               [publishInformation]="activeTask?.valoremPublishInformation"
                               (updateActiveTask)="updateActiveTask($event)"></valorem-approval-matrix>
      <close-valuation-event *ngIf="activePortfolio?.oid && activeTask?.projectTaskId && activeTask.taskTypeId == taskTypes.CloseValuationEvent"
                             (selectedCloseOption)="onSelectedCloseOption($event)"
                             (selectedCopyPropertiesOption)="onSelectedCopyPropertiesOption($event)"
                             (selectedFxTablesOption)="onSelectedFxTablesOption($event)"
                             (newValuationName)="onNewValuationName($event)"
                             (newValuationDate)="onNewValuationDate($event)"
                             [projectId]="projectId"
                             [portfolioId]="activeTask?.taskValuationPortfolioId"
                             [currentTask]="activeTask">
      </close-valuation-event>
      <valuation-event-setup-form *ngIf="activeTask?.taskTypeId == taskTypes.ValuationEventFunction"
                                  [disableEditing]="activePortfolio.isFinalized"
                                  [portfolioId]="activePortfolio?.oid">
      </valuation-event-setup-form>
      <valuation-effective-dates-setup *ngIf="activeTask?.taskTypeId == taskTypes.ValuationEffectiveDatesSetup"
                                       [projectId]="projectId"
                                       [disableFunctions]=" !(!activeTask?.isCompleted && activeTask?.taskActionStage == actionStage.Waiting) || activePortfolio.isFinalized"
                                       [selectedValuationEventId]="activePortfolio?.oid"></valuation-effective-dates-setup>
      <raci-checklist-pane [checklist]="activeChecklist"></raci-checklist-pane>
    </div>
    <div class="right participants-pane"
         *ngIf="activeTab == raciTabs.Overview && (showRaciParticipants || isValuationEventsDisplayed || shouldShowApprovalHistory)">
      <raci-participants-pane *ngIf="showRaciParticipants && !shouldShowApprovalHistory"></raci-participants-pane>
      <tree-list-view class="raci-valuation-events-view"
                      *ngIf="activeTab == raciTabs.Overview && !showRaciParticipants && isValuationEventsDisplayed"
                      [data]="parentChildValuationEvents"
                      (onSetActive)="setActivePortfolio($event)"
                      [activeOid]="activePortfolio?.oid"
                      [showConfirmDialog]="showConfirmDialog"></tree-list-view>
      <approval-history *ngIf="shouldShowApprovalHistory && activeTask"
                        [activeTask]="activeTask">
      </approval-history>
    </div>
    <div class="user-tasks-pane"
         *ngIf="activeTab == raciTabs.UserDashboard">
      <div class="valuation-event-title">
        <h3>
          {{'raci.userDashboardHost.userTasks' | translate}}
        </h3>
      </div>
      <user-tasks-pane [tasks]="userDashboardTasks"
                       [refresh]="refreshUserTasksList"
                       (onChangeUserActiveTask)="setActiveUserTask($event)"
                       (approvalMatrixOfTask)="setApprovalMatrix($event)"
                       (approvalMatrixOfFunctionTask)="setapprovalMatrixOfFunctionTask($event)"
                       (generalTaskApprovalMatrix)="setGeneralTaskApprovalMatrix($event)"></user-tasks-pane>
    </div>
    <div class="approval-matrix"
         *ngIf="activeTab == raciTabs.UserDashboard">
      <approval-matrix [groupBy]="groupBy"
                       [approvalMatrix]="approvalMatrixOfTask"
                       [hideApprovalMatrix]="hideApprovalMatrix"
                       [currentUser]="currentUser"
                       (refreshUserTaskList)="refreshUserTasks()"
                       (refreshApprovalMatrix)="updateCurrentApprovalMatrix($event)"
                       (updateUserDashboardCompleteTaskStatus)="setUserDashboardCompleteTaskStatus($event)"
                       *ngIf="!showRaciParticipants && approvalMatrixOfTask && userDashboardActiveTask && activeTask?.taskTypeId != taskTypes.ValoremFunction
                       && activeTask?.taskTypeId != taskTypes.ArgusFunction && activeTask?.taskTypeId != taskTypes.ArgusSyncFunction
                       && activeTask?.taskTypeId != taskTypes.CloseValuationEvent
                       && activeTask?.taskTypeId != taskTypes.ValuationEventFunction
                       && activeTask?.taskTypeId != taskTypes.ValuationEffectiveDatesSetup"></approval-matrix>
      <general-tasks-approval-matrix [generalTaskApprovalMatrix]="generalTaskApprovalMatrix"
                                     [groupBy]="groupBy"
                                     [currentUser]="currentUser"
                                     *ngIf="generalTaskApprovalMatrix"></general-tasks-approval-matrix>
      <valorem-approval-matrix *ngIf="activeTask?.taskTypeId == taskTypes.ValoremFunction"
                               [data]="approvalMatrixOfFunctionTask"
                               [groupBy]="groupBy"
                               [showTitleInfo]="true"
                               [currentTask]="activeTask"
                               [allowApproving]="isApprovingAllowed()"
                               [publishInformation]="activeTask?.valoremPublishInformation"></valorem-approval-matrix>
      <argus-approval-matrix *ngIf="activeTask?.taskTypeId == taskTypes.ArgusFunction"
                             [data]="approvalMatrixOfFunctionTask"
                             [currentUser]="currentUser"
                             [showTitleInfo]="true"
                             [groupBy]="groupBy"
                             [allowSync]="true"
                             (onSyncWithArgus)="syncWithArgus($event)"
                             [currentTask]="activeTask"></argus-approval-matrix>
      <argus-push-matrix *ngIf="activeTask?.taskTypeId == taskTypes.ArgusSyncFunction"
                         [data]="approvalMatrixOfFunctionTask"
                         [currentUser]="currentUser"
                         [showTitleInfo]="true"
                         [groupBy]="groupBy"
                         [allowSync]="true"
                         [currentTask]="activeTask"></argus-push-matrix>
      <valuation-event-setup-form *ngIf="activeTask?.taskTypeId == taskTypes.ValuationEventFunction"
                                  [portfolioId]="activePortfolio?.oid"
                                  [showTitleInfo]="true">
      </valuation-event-setup-form>
      <close-valuation-event *ngIf="activeTask?.taskTypeId == taskTypes.CloseValuationEvent"
                             (selectedCloseOption)="onSelectedCloseOption($event)"
                             (selectedCopyPropertiesOption)="onSelectedCopyPropertiesOption($event)"
                             (selectedFxTablesOption)="onSelectedFxTablesOption($event)"
                             (newValuationName)="onNewValuationName($event)"
                             (newValuationDate)="onNewValuationDate($event)"
                             [projectId]="projectId"
                             [portfolioId]="activePortfolio?.oid"
                             [showTitleInfo]="true"
                             [currentTask]="activeTask">
      </close-valuation-event>
      <valuation-effective-dates-setup *ngIf="activeTask?.taskTypeId == taskTypes.ValuationEffectiveDatesSetup"
                                       [showTitleInfo]="true"
                                       [projectId]="projectId"
                                       [disableFunctions]="!(!activeTask?.isCompleted && activeTask?.taskActionStage == actionStage.Waiting)"
                                       [selectedValuationEventId]="activePortfolio?.oid"></valuation-effective-dates-setup>
    </div>
  </div>
</div>
<data-loader></data-loader>
<div class="k-overlay" *ngIf="showGetDataFromArgusDialog || isSyncWithArgusDisplayed || isPublishToValoremDisplayed || showCloseValuationEventDialog"></div>
<data-from-argus-dialog *ngIf="showGetDataFromArgusDialog"
                        [canClose]="true"
                        [properties]="properties"
                        (closePane)="closeAllPanes()"
                        (sholudContinueWithArgus)="continueWithArgus()">
</data-from-argus-dialog>
<report-argus-sync-dialog *ngIf="isSyncWithArgusDisplayed"
                          [canClose]="true"
                          [reportIds]="selectedReportIds"
                          (closePane)="closeAllPanes()">
</report-argus-sync-dialog>
<valorem-publish-task *ngIf="isPublishToValoremDisplayed"
                      [valuationEventId]="activePortfolio?.oid"
                      (onPublishInformationChange)="onValoremPublishInformationChange($event)">
</valorem-publish-task>
<close-valuation-event-dialog *ngIf="showCloseValuationEventDialog"
                              [portfolio]="activePortfolio"
                              [dialogMessage]="closeValEventDialogMessage"
                              [canClose]="true"
                              [optionSelected]="closeValEventOptionSelected"
                              [copyProperties]="copyProperties"
                              [copyFxTables]="copyFxTables"
                              [valuationDate]="newValuationDate"
                              [valuationName]="newValuationName"
                              (onCloseProject)="onCloseProject()"
                              (onCreateValuationEvent)="onCreateValuationEvent()">
</close-valuation-event-dialog>
<div class="approval-history" *ngIf="shouldShowTaskApprovalHistory">
  <approval-history *ngIf="activeTask"
                    [activeTask]="activeTask?.taskId">
  </approval-history>
</div>
